<template lang="pug">
b-form(@submit.prevent="submit()")
  b-form-group(label="Partner")
    b-form-select(v-model="partner" label="name" placeholder="Selecciona un partner")
      b-form-select-option(:value="null") Sin partner
      b-form-select-option(v-for="partner in partners" :key="partner.value" :value="partner.value") {{ partner.text }}
  .d-flex.justify-content-end
    b-button(type="submit" variant="primary") Asignar
</template>

<script>
import { PARTNERS, PARTNERS_TEXT } from '@/constants/partners'
export default {
  data() {
    return {
      partner: null,
      partners: Object.entries(PARTNERS).map(([key, value]) => ({
        text: PARTNERS_TEXT[value],
        value
      }))
    }
  },
  methods: {
    async submit() {
      this.$emit('submit', this.partner)
    }
  }
}
</script>